<template>
    <div class="final-pr">
        <div v-if="isCompleted" class="final-pr-header">
            <div class="pr-final-header-left">
                <img :src="require('@/assets/icons/pr-completed.svg')" />
                <div class="completed-msg">
                    <h2 class="title">PR Strategy Playbook generated</h2>
                </div>
            </div>
            <div class="pr-final-header-right">
                <div class="pr-final-btn-wrapper">
                    <img :src="require('@/assets/icons/share.svg')"></img>
                    <p class="home-btn-text">Share</p>
                </div>

                <button class="pr-final-btn-wrapper" @click="goToHome()">
                    <img :src="require('@/assets/icons/home.svg')" alt="">
                    <p class="home-btn-text">Go to Dashboard</p>
                </button>

                <button class="pr-final-btn-wrapper" :disabled="downloadLoader" @click="downloadFinalPr()">

                    <div class="download-wrapper">
                        <Svg :src="require('@/assets/icons/download.svg')" fill="white"></Svg>
                        <p>Download</p>
                        <v-progress-circular v-if="downloadLoader" indeterminate :size="18"
                            :width="2"></v-progress-circular>
                    </div>

                </button>
            </div>
        </div>
        <div class="body">
            <div class="body-wrapper">
                <div class="body-content" v-html="cleanedPrCampaignContent">
                </div>
            </div>

        </div>
    </div>

</template>

<script>
import { marked } from 'marked';
import { downloadPr } from '@/helper/downloadPr';
export default {
    data() {
        return {
            downloadLoader: false,
            prCampaignContent: null,
        }
    },
    props: {
        prCampaign: {
            type: Object
        },
        
        isCompleted: {
            type: Boolean
        }
    },
    computed: {

        cleanedPrCampaignContent() {
            return  this.prCampaign.prCampaignContent;
        }
    },
    methods: {
        goToHome() {
            this.$router.push({ name: 'PrPlanHome' });
        },
        async downloadFinalPr() {
            this.downloadLoader = true;
            const payload = {
                prCampaignId: this.$route.params.prCampaignId,
                flowType: "PR_CAMPAIGN"
            }
            await downloadPr(payload, this.prCampaign.title);
            this.downloadLoader = false;
        },
    },
    mounted() {
        this.prCampaignContent = this.prCampaign.prCampaignContent;
    }

}

</script>

<style scoped>
.final-pr {
    display: flex;
    flex-direction: column;
    padding: 2rem;
    width: 80%;
    overflow: hidden;
    gap: 2rem;
    box-sizing: border-box;
}

.final-pr-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.5em;
    background: var(--primary-gradient-bar-with-black);
    padding: 1rem 1.5rem;
    border-radius: 8px;
    color: var(--secondary-font-color);
    justify-content: space-between;
}

.pr-final-header-left {
    display: flex;
    gap: 1rem;
}

.pr-final-header-right {
    display: flex;
    flex-direction: row;
    gap: 1rem;
}

.completed-msg {
    display: flex;
    flex-direction: column;
    gap: 4px;
    color: white;
}

.pr-final-btn-wrapper {
    display: flex;
    justify-content: center;
    background: #FFFFFF1F;
    gap: 4px;
    padding: 0.5rem 1rem;
    border: 1px solid #FFFFFF33;
    align-items: center;
    border-radius: 8px;
    font-size: var(--normal-font-size);
}

.download-wrapper {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
}

.body {
    background-color: var(--secondary-font-color);
    border-radius: 8px;
    padding: 1rem;
    overflow: hidden;
}

.body-wrapper {
    height: 100%;
    overflow: auto;
    scrollbar-width: none;
    will-change: transform;

}

.body-content {
    display: flex;
    background-color: white;
    flex-direction: column;
    border-radius: 6px;
    padding: 1rem;
    color: black;
    gap: 1rem;
}

.body-content ul {
    padding: 1rem !important;
}

.title {
    display: flex;
    padding: 8px;
    flex: 1;
    justify-content: center;
    align-items: center;
}
</style>